import React from 'react';
import { Tooltip } from 'swag-client-common/components/info/tooltip';
import { VALIDATION_ERROR_MESSAGES } from 'swag-client-common/constants/validation-error-messages';
export const GiveawayNotValidButtonTooltip = ({
  children,
  disabled,
  tooltipErrorMessage = VALIDATION_ERROR_MESSAGES.NOT_VALID_ON_SAVE
}) => {
  if (!disabled) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, children);
  }
  return /*#__PURE__*/React.createElement(Tooltip, {
    title: tooltipErrorMessage
  }, children);
};